import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/jobesta-theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';
import { posthogConfig, posthogOptions } from './services/posthogService';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Conditionally wrap with PostHogProvider based on configuration
const isPostHogEnabled = posthogConfig.enabled && posthogConfig.apiKey;

root.render(
  <React.StrictMode>
    {isPostHogEnabled ? (
      <PostHogProvider
        apiKey={posthogConfig.apiKey}
        options={posthogOptions}
      >
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
